import { Service } from '@angular/core';

@Service({ autoProvided: false })
export class StartschermCoreOptions {
    isLocal = false;
}
